import React from "react";

export const DidomiFavIcon = ({ className, size = 30 }) => (
  <svg
    className={className}
    width={size}
    height={size}
    viewBox="0 0 120 120"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="120" height="120" rx="15" fill="#04092D" />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M22.5014 84.9066C22.5014 85.3614 22.87 85.73 23.3248 85.73H45.9546C51.4675 85.73 56.3641 84.6899 60.6232 82.5848L60.63 82.5814C64.8828 80.4305 68.2248 77.4374 70.6338 73.6027L70.6362 73.5987C73.0526 69.7029 74.2469 65.1597 74.2469 59.9995C74.2469 54.7937 73.0534 50.248 70.6337 46.3963C68.2244 42.5609 64.8812 39.5906 60.6266 37.487C56.3667 35.3334 51.4688 34.2689 45.9546 34.2689H23.3248C22.87 34.2689 22.5014 34.6376 22.5014 35.0924V84.9066ZM58.9804 67.7639L58.9741 67.7747C57.7278 69.9557 55.95 71.6487 53.6191 72.8595C51.339 74.0213 48.6034 74.6185 45.3853 74.6185H35.6766V45.3805H45.3853C48.6003 45.3805 51.3326 46.0002 53.6107 47.2062L53.619 47.2105L53.6277 47.215C55.954 48.3781 57.7289 50.0452 58.9741 52.2243L58.9785 52.2319L58.9842 52.2415C60.2685 54.3672 60.9293 56.9416 60.9293 59.9995C60.9293 63.0069 60.2698 65.5852 58.9804 67.7639Z"
      fill="white"
    />
    <path
      d="M84.3234 84.9075C84.3234 85.3623 84.692 85.7309 85.1468 85.7309H96.6752C97.1299 85.7309 97.4986 85.3623 97.4986 84.9075V35.0933C97.4986 34.6385 97.1299 34.2698 96.6752 34.2698C89.8527 34.2698 84.3212 39.7991 84.3207 46.6216C84.3196 59.3835 84.3234 72.1455 84.3234 84.9075Z"
      fill="white"
    />
  </svg>
);
